import * as React from "react";
import { BILLABLE, JOB, REVENUE, PERFORMANCE, TIMESHEET } from "icons";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarProvider,
  SidebarRail,
} from "ui/components/sidebar";
import { NavItem } from "@/components/nav/item";
import { NavSubItem } from "@/components/nav/sub-item";
import { Outlet } from "react-router-dom";
import { CurrencyProvider, useCurrencies } from "./contexts/currency-context";
import Loader from "@/components/loader";
import { CollapsibleReportHeader } from "./collapsible-header";

function ReportsContent({ children, ...props }) {
  const { isLoading } = useCurrencies();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <SidebarProvider
        className="w-fit overflow-hidden max-h-dvh"
        name="project"
      >
        <Sidebar
          collapsible="icon"
          {...props}
          className="sidebar-height border-r bg-red-400 left-auto inset-y-auto top-16"
        >
          <SidebarHeader className="px-3">
            <CollapsibleReportHeader />
          </SidebarHeader>
          <SidebarContent>
            <SidebarGroup>
              <SidebarMenu>
                <NavItem
                  title="Billables"
                  icon={BILLABLE}
                  url={`/reports/billables`}
                  matchExact={true}
                  requiredPermissions={{
                    collection: "billables",
                    type: "collection",
                  }}
                >
                  <NavSubItem
                    title="Dashboard"
                    url={`/reports/billables/dashboard`}
                    requiredPermissions={{
                      collection: "billables",
                      type: "key",
                      key: "amount",
                    }}
                  />
                  <NavSubItem
                    title="Extensions"
                    url={`/reports/billables/extensions`}
                    requiredPermissions={{
                      collection: "billable_extensions",
                      type: "collection",
                    }}
                  />
                  <NavSubItem
                    title="Overdue"
                    url={`/reports/billables/overdue`}
                    requiredPermissions={{
                      collection: "billables",
                      type: "collection",
                    }}
                  />
                  <NavSubItem
                    title="Slippage"
                    url={`/reports/billables/slippage`}
                    requiredPermissions={{
                      collection: "billables",
                      type: "key",
                      action: "read",
                      key: "amount",
                    }}
                  />

                  <NavSubItem
                    title="Status"
                    url={`/reports/billables/status`}
                    requiredPermissions={{
                      collection: "companies",
                      type: "collection",
                    }}
                  />
                  <NavSubItem
                    title="Collections"
                    url={`/reports/billables/type`}
                    requiredPermissions={{
                      collection: "billables",
                      type: "key",
                      action: "read",
                      key: "amount",
                    }}
                  />
                </NavItem>
                <NavItem
                  title="Revenue"
                  icon={REVENUE}
                  matchExact={true}
                  url={`/reports/revenue/dashboard`}
                  requiredPermissions={{
                    collection: "billables",
                    type: "collection",
                  }}
                />
                <NavItem
                  title="Jobs"
                  icon={JOB}
                  matchExact={true}
                  url={`/reports/jobs`}
                >
                  <NavSubItem title="Overview" url={`/reports/jobs/overview`} />
                  <NavSubItem
                    title="Extensions"
                    url={`/reports/jobs/extensions`}
                    requiredPermissions={{
                      collection: "job_extensions",
                      type: "collection",
                    }}
                  />
                  <NavSubItem title="Overrun" url={`/reports/jobs/overrun`} />
                  <NavSubItem title="Underrun" url={`/reports/jobs/underrun`} />
                  <NavSubItem title="Ongoing" url={`/reports/jobs/ongoing`} />
                </NavItem>
                <NavItem
                  title="Timesheet"
                  icon={TIMESHEET}
                  url={`/reports/timesheet`}
                  matchExact={true}
                >
                  <NavSubItem
                    title="Department"
                    url={`/reports/timesheet/department`}
                  />
                  <NavSubItem
                    title="Employee"
                    url={`/reports/timesheet/employees`}
                  />
                  {/* <NavSubItem
                    title="Hierarchy"
                    url={`/reports/timesheet/hierarchy`}
                  /> */}
                  {/* <NavSubItem title="Team" url={`/reports/timesheet/team`} /> */}
                  <NavSubItem
                    title="Unlocked"
                    url={`/reports/timesheet/unlocked`}
                  />
                  <NavSubItem
                    title="Unreviewed Hours By JC"
                    url={`/reports/timesheet/unreviewed-by-jc`}
                  />
                </NavItem>
                <NavItem
                  title="Performance"
                  icon={PERFORMANCE}
                  matchExact={true}
                  url={`/reports/performance`}
                />
              </SidebarMenu>
            </SidebarGroup>
          </SidebarContent>
          <SidebarRail />
        </Sidebar>
      </SidebarProvider>
      <Outlet />
    </>
  );
}

export default function ReportsLayout({ children, ...props }) {
  return (
    <CurrencyProvider>
      <ReportsContent {...props} />
    </CurrencyProvider>
  );
}
